import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { CustomButton, TableData } from '../../../components'
import { errorAlert } from '../../../helpers/alerts';
import { getAlertsService, updateAlertService } from 'services/admin/alertsService';
import { setAlerts, setCurrentAlert, updateAlert } from 'redux/slices/admin/alertSlice';
import moment from 'moment';
import { AddOutlined, EditOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

const SystemAlertsScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { alerts } = useSelector(store => store.alert);
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true);
    getAlertsService("sistema").then((result) => {
      dispatch(setAlerts(result))
    }).catch(error => errorAlert(error))
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  const handlerEdit = (row) => {
    dispatch(setCurrentAlert(row));
    navigate("editar");
  };

  const handlerCheck = async ({ id }, currentValue) => {
    const value = !currentValue;
    updateAlertService(id, { state: value }).then(({ state, updatedAt }) => {
      dispatch(updateAlert({ id, data: { state, updatedAt } }));
    }).catch(error => errorAlert(error))
  };

  return (
    <Box mt={2}>
      {/* El boton va fuera de la tabla: `headerButtons` de TableData solo se pinta
          cuando el buscador esta activo, y esta pantalla no lo usa. */}
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <CustomButton
          icon={<AddOutlined />}
          sx={{ padding: '8px 16px' }}
          name={"Alerta"}
          click={() => navigate("crear")}
        />
      </Box>
      <TableData
        dataRows={alerts}
        loading={loading}
        search={false}
        dataTitle={[
          "Nombre",
          "Contacto",
          // "Telefonos",
          "Estado",
          "Activacion/Desactivacion"
        ]}
        formatter={({ name, emails, numbers, state, updatedAt }) => [
          name,
          {
            type: "text",
            value:
              (emails?.length ? emails?.join(" ") : "") +
              (numbers?.length ? "\n" + numbers?.join("\n") : ""),
            maxWidth: 100
          },
          // emails?.join("\n\r"),
          // numbers?.join("\n\r"),
          { name: "state", type: "boolean", value: state },
          moment(updatedAt).format('DD/MM/YYYY HH:mm:ss '),
        ]}
        onChecked={handlerCheck}
        actions={[
          {
            label: "Editar",
            icon: <EditOutlined />,
            onClick: (data) => handlerEdit(data)
          },
        ]}
      />
    </Box>

  )
}

export default SystemAlertsScreen